<template>
  <div>
    <img
      v-if="capacity == 'Full'"
      src="@/assets/media/full-pink.png"
      class="h-lg-150px float-left"
    />
    <img
      v-if="capacity == 'Half'"
      src="@/assets/media/half-pink.png"
      class="h-lg-150px float-left"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "BarrelIcon",
  props: {
    capacity: {
      required: true,
      type: String,
    },
  },
});
</script>

<style></style>
